<div #serviceUnavailable></div>
@if (banner()?.showcaseUnifiedPortal && !isHidden() && $any(banner()?.startDate) < utc && $any(banner()?.endDate) > utc) {
  <jtm-banner [banner]="banner()" (hideBanner)="hideBanner()"></jtm-banner>
}
<router-outlet></router-outlet>
<app-notification></app-notification>
<app-cookie-consent-bar [checkTokenClaim]="true"></app-cookie-consent-bar>
